import { isNullOrUndefined } from "@clipboard-health/util-ts";

import {
  type AccountManagerResponse,
  type BillingSpecialistResponse,
  type WorkHours,
} from "../api/types";
import { type CBHSpecialistResponse } from "../api/useGetCBHSpecialist";
import { CbhSpecialistType } from "../constants";

function getHourIn12HourFormat(hour: number) {
  const integerPart = Math.floor(hour);
  const decimalPart = hour - integerPart;
  const minutes = Math.round(decimalPart * 60);
  const formattedHour = integerPart > 12 ? integerPart - 12 : integerPart;
  return minutes > 0 ? `${formattedHour}:${minutes}` : `${formattedHour}`;
}

export function getCBHSpecialistProfile(
  specialistResponse: CBHSpecialistResponse,
  type: CbhSpecialistType
) {
  const { name, phone, email, workHours } =
    type === CbhSpecialistType.BILLING_SPECIALIST
      ? (specialistResponse as BillingSpecialistResponse).data.attributes
      : (specialistResponse as AccountManagerResponse).included?.find(
          (specialist) =>
            specialist.id ===
            (specialistResponse as AccountManagerResponse).data.relationships.accountManager.data.id
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        )?.attributes || {};

  const workTimings = getCBHSpecialistWorkingTimings(workHours);

  return { name, phone, email, workTimings };
}

export function getCBHSpecialistWorkingTimings(workHours?: WorkHours) {
  if (isNullOrUndefined(workHours)) {
    return "";
  }

  const { start, end, timezone } = workHours;
  if (isNullOrUndefined(start) || isNullOrUndefined(end) || isNullOrUndefined(timezone)) {
    return "";
  }

  return `[Mon-Fri ${getHourIn12HourFormat(start)}-${getHourIn12HourFormat(end)} ${timezone}]`;
}
